<template>
  <div>
    <el-button
      v-if="allowCreate"
      type="primary"
      icon="el-icon-plus"
      size="mini"
      class="add-material-btn"
      @click="handleShowReplace"
    >
      物料替换
    </el-button>
    <ul class="replace-list">
      <template v-if="replaceList.length">
        <li v-for="(item, index) in replaceList" :key="index" class="replace-item">
          <section>
            <div class="replace-col">
              <p class="title">物料描述: </p>
              <p>{{ item.desc }}</p>
            </div>
            <div class="replace-col">
              <p class="title">上传附件: </p>
              <show-file-list :file-list="item.fileList"></show-file-list>
            </div>
            <div v-if="item.createUser" class="replace-col">
              <p class="title">提交人: </p>
              <p>{{ item.createUser }}</p>
            </div>
            <div v-if="item.insertTime" class="replace-col">
              <p class="title">提交时间: </p>
              <p>{{ item.insertTime }}</p>
            </div>
          </section>
          <i v-if="!item.id" class="del-icon el-icon-error" @click="handleDeleteReplace(index)" />
        </li>
      </template>
    </ul>

    <el-dialog title="新增物料替换" :visible.sync="showReplace" destroy-on-close :close-on-click-modal="false">
      <el-form :model="form" label-width="80px">
        <el-form-item label="物料描述" prop="desc">
          <el-input
            v-if="isCreate"
            type="textarea"
            v-model="form.desc"
            :rows="5"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传附件">
          <material-upload :file-list.sync="form.fileList"></material-upload>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleAdd">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import ShowFileList from '@/components/ShowFileList/index.vue'
import MaterialUpload from './MaterialUpload.vue'

const defaultReplaceObj = () => {
  return {
    id: null,
    desc: '',
    fileList: []
  }
}

export default {
  name: 'ReplaceMaterial',
  components: {
    ShowFileList,
    MaterialUpload
  },
  props: {
    replaceList: {
      type: Array,
      default: () => []
    },
    allowCreate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showReplace: false,
      form: {}
    }
  },

  computed: {
    /**
     * @returns {Boolean}
     */
    isCreate() {
      return !this.form.id
    }
  },

  methods: {
    handleShowReplace() {
      this.form = defaultReplaceObj()
      this.showReplace = true
    },

    handleClose() {
      this.showReplace = false
      this.form = defaultReplaceObj()
    },

    handleAdd() {
      this.replaceList.push(cloneDeep(this.form))
      this.handleClose()
    },

    handleDeleteReplace(index) {
      this.$confirm('确定要删除该条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.replaceList.splice(index, 1)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.replace-list {
  margin-top: 10px;
  border-top: 1px solid #eee;

  .replace-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }

  .replace-col {
    display: flex;
    align-items: baseline;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }

    .title {
      flex: 0 0 60px;
      text-align: right;
      font-weight: 500;
      margin-right: 10px;
    }
  }
}

.del-icon {
  margin-left: 10px;
  font-size: 16px;
  cursor: pointer;
}

::v-deep .el-upload-list__item:first-child {
  margin-top: 0;
}
</style>
